/* eslint-disable */
export default {
  noResultFoundFor: '다음에 대한 결과가 없음',
  search: '검색',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
